import React from 'react';

const ModalMenuPrimary = () => {
    return (
        <nav className="menu-primary">
            <ul className="nav flex-column">
                <li className="nav-item">
                    <a title="About Us" href={ process.env.PUBLIC_URL + "/#about-us" }>About Us</a>
                </li>

                <li className="nav-item">
                    <a title="Appointments" href={ process.env.PUBLIC_URL + "/#appointments" }>Appointments</a>
                </li>

                <li className="nav-item">
                    <a title="Treatments" href={ process.env.PUBLIC_URL + "/#treatments" }>Treatments</a>
                </li>

                <li className="nav-item">
                    <a title="Physiotherapist"  href={ process.env.PUBLIC_URL + "/#our-team" }>Physiotherapist</a>
                </li>

                <li className="nav-item">
                    <a title="Contact Us" href={ process.env.PUBLIC_URL + "/#contact-us" }>Contact Us</a>
                </li>
            </ul>
        </nav>
    );
};

export default ModalMenuPrimary;
